import React from 'react';

interface SunIconProps {
  size?: number;
  color?: string;
}

/**
 * SunIcon Component
 * @description Sun icon representing light theme mode
 * @param size - Icon size in pixels (default: 24)
 * @param color - Icon color (default: 'currentColor')
 */
export const SunIcon: React.FC<SunIconProps> = ({ 
  size = 24, 
  color = 'currentColor' 
}) => {
  return (
    <svg 
      width={size}
      height={size}
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="4" stroke={color} strokeWidth="2" fill="none"/>
      <path 
        d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SunIcon;

